import { createStore, combineReducers, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import { composeWithDevTools } from 'redux-devtools-extension';
import { richListReducer } from './reducers/RichListReducers';
import { timeSeriesReducer } from './reducers/TimeSeriesReducers';

const reducer = combineReducers({
  richLists: richListReducer,
  timeSeries: timeSeriesReducer,
});

const middleware = [thunk];

const store = createStore(
  reducer,
  composeWithDevTools(applyMiddleware(...middleware))
);

export default store;
